import { consoleLog } from "../helpers/index";
import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";
const GlobalContext = createContext({});

export const GlobalContextProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState({});
  const [currentRoute, setCurrentRoute] = useState("Main Dashboard");
  const [subCurrentRoute, setSubCurrentRoute] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const initialIterinaryFormData = useMemo(
    () => ({
      tripName: "",
      numberOfDaysSelected: 0,
      featured: "",
      topDestination: 0,
    }),
    []
  );
  const initialConfigState = useMemo(
    () => ({
      key: "",
      value: "",
      status: "active",
      comment: "",
    }),
    []
  );

  // Sytem prompts form states
  const initialFormState = useMemo(
    () => ({
      key: "",
      category: "",
      value: "",
      status: "active",
      comment: "",
      configCategory: "llmCategory",
    }),
    []
  );
  const [formData, setFormData] = useState(initialFormState);

  const [fetchSystemPrompts, setFetchSystemPrompts] = useState(false);

  const [iterinaryFormData, setIterinaryFormData] = useState(
    initialIterinaryFormData
  );

  // destination form State
  const initialDestinationFormState = useMemo(
    () => ({
      Name: "",
      Type: "",
      Title: "",
      Subtitle: "",
      Region: "",
    }),
    []
  );
  const [isOpenDestinationEditForm, setIsOpenDestinationEditForm] =
    useState(false);
  const [fetchDestinations, setFetchDestinations] = useState(false);
  const [destinationFormData, setDestinationFormData] = useState(
    initialDestinationFormState
  );

  // Activities data
  const initialActivitiesFormState = useMemo(
    () => ({
      Activity: "",
      Group: "",
      Subtitle: "",
    }),
    []
  );
  const [isOpenActivitiesEditForm, setIsOpenActivitiesEditForm] =
    useState(false);
  const [fetchActivities, setFetchActivities] = useState(false);
  const [activitiesFormData, setActivitiesFormData] = useState(
    initialActivitiesFormState
  );

  // Website data(web Contents) data
  const initialWebContentsFormState = useMemo(
    () => ({
      section: "",
      key: "",
      value: "",
    }),
    []
  );
  const [isOpenWebsiteContentsEditForm, setIsOpenWebsiteContentsEditForm] =
    useState(false);
  const [fetchWebContents, setFetchWebContents] = useState(false);
  const [webContentsFormData, setWebContentsFormData] = useState(
    initialWebContentsFormState
  );

  // Website Prompts data
  const initialWebPromptsFormState = useMemo(
    () => ({
      title: "",
      value: "",
      imageUrl: "",
      sortOrder: "",
    }),
    []
  );
  const [isOpenWebsitePromptsEditForm, setIsOpenWebsitePromptsEditForm] =
    useState(false);
  const [fetchWebPrompts, setFetchWebPrompts] = useState(false);
  const [webPromptsFormData, setWebPromptsFormData] = useState(
    initialWebPromptsFormState
  );

  // Message data
  const initialMessageFormState = useMemo(
    () => ({
      title: "",
      value: "",
      imageUrl: "",
      sortOrder: "",
    }),
    []
  );
  const [isOpenMessageEditForm, setIsOpenMessageEditForm] = useState(false);
  const [fetchMessage, setFetchMessage] = useState(false);
  const [messageFormData, setMessageFormData] = useState(
    initialMessageFormState
  );

  // countries data
  const initialCountriesFormState = useMemo(
    () => ({
      name: "",
      code: "",
      iso: "",
    }),
    []
  );
  const [isOpenCountriesEditForm, setIsOpenCountriesEditForm] = useState(false);
  const [fetchCountries, setFetchCountries] = useState(false);
  const [countriesFormData, setCountriesFormData] = useState(
    initialCountriesFormState
  );

  //FAQ

  const initialFaqFormState = useMemo(
    () => ({
      key: "",
      title: "",
      description: "",
    }),
    []
  );
  const [isOpenFaqEditForm, setIsOpenFaqEditForm] = useState(false);
  const [fetchFaq, setFetchFaq] = useState(false);
  const [faqFormData, setfaqFormData] = useState(initialFaqFormState);

  // Prompt fragements
  const initialPromptFragmentsFormState = useMemo(
    () => ({
      key: "",
      name: "",
      value: "",
      comment: "",
      isActive: "active",
      LLM: "anthropic",
    }),
    []
  );
  const [isOpenPromptFragmentsEditForm, setIsOpenPromptFragmentsEditForm] =
    useState(false);
  const [fetchPromptFragments, setFetchPromptFragments] = useState(false);
  const [promptFragmentsFormData, setPromptFragmentsFormData] = useState(
    initialPromptFragmentsFormState
  );
  const [
    isOpenPromptFragmentsPreviewModal,
    setIsOpenPromptFragmentsPreviewModal,
  ] = useState(false);

  // New systemPrompts data
  const initialSysPromptsFormState = useMemo(
    () => ({
      key: "",
      version: "",
      isActive: "active",
      comment: "",
      value: "",
    }),
    []
  );
  const [fetchSysPrompts, setFetchSysPrompts] = useState(false);
  const [sysPromptsFormData, setSysPromptsFormData] =
    useState(initialFormState);
  const [isOpenSystemPrompsPreviewModal, setIsOpenSystemPromptsPreviewModal] =
    useState(false);
  const [isOpenSystemPromptsValuesModal, setIsOpenSystemPromptsValuesModal] =
    useState(false);

  const [accessJWT, setAccessJWT] = useState("");

  // system config form state
  const [fetchConfig, setFetchConfig] = useState(false);
  const [configCategories, setConfigCategories] = useState([]);

  const [tableData, setTableData] = useState([]);
  consoleLog([setTableData]);
  const [iterinaryList, setIterinaryList] = useState([]);

  const [filterData, setFilterData] = useState([]);

  // const getFilterdata = useCallback(async () => {
  //   const token = localStorage.getItem("jwtToken");
  //   const response = await getFilterDataAPI(
  //     {
  //       name: ["prompt", "destination", "config", "promptFragment"],
  //     },
  //     () => {},
  //     token
  //   );
  //   if (response) {
  //     setFilterData(response);
  //   }
  // }, [setFilterData]);

  // const getSystemPromptData = async () => {
  //   try {
  //     // const response = await axios.get(`${ENDPOINT}/app/systemprompt`);
  //     const response = await axios.get(`${ENDPOINT}/app/v1/systemprompt`);
  //     if (response.data && response.data.data) {
  //       setTableData(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // prompt variables data
  const initialPromptVariablesFormState = {
    name: "",
  };
  const [isOpenPromptVariablesEditForm, setIsOpenPromptVariablesEditForm] =
    useState(false);
  const [fetchPromptVariables, setFetchPromptVariables] = useState(false);
  const [promptVariablesFormData, setPromptVariablesFormData] = useState(
    initialPromptVariablesFormState
  );

  const value = {
    // prompt variables Data
    searchQuery, // Include searchQuery here
    setSearchQuery,
    initialPromptVariablesFormState,
    isOpenPromptVariablesEditForm,
    setIsOpenPromptVariablesEditForm,
    fetchPromptVariables,
    setFetchPromptVariables,
    promptVariablesFormData,
    setPromptVariablesFormData,

    // filter Data
    filterData,
    setFilterData,

    // New System prompts
    fetchSysPrompts,
    setFetchSysPrompts,
    sysPromptsFormData,
    setSysPromptsFormData,
    initialSysPromptsFormState,
    isOpenSystemPromptsValuesModal,
    setIsOpenSystemPromptsValuesModal,

    // Prompt fragements form state values
    initialPromptFragmentsFormState,
    isOpenPromptFragmentsEditForm,
    setIsOpenPromptFragmentsEditForm,
    fetchPromptFragments,
    setFetchPromptFragments,
    promptFragmentsFormData,
    setPromptFragmentsFormData,
    isOpenPromptFragmentsPreviewModal,
    setIsOpenPromptFragmentsPreviewModal,

    // jwt
    accessJWT,
    setAccessJWT,

    // destination form state values
    destinationFormData,
    setDestinationFormData,
    initialDestinationFormState,
    fetchDestinations,
    setFetchDestinations,
    isOpenDestinationEditForm,
    setIsOpenDestinationEditForm,

    // Activities form State values
    initialActivitiesFormState,
    isOpenActivitiesEditForm,
    setIsOpenActivitiesEditForm,
    fetchActivities,
    setFetchActivities,
    activitiesFormData,
    setActivitiesFormData,

    // Website contents(website data) form state values
    initialWebContentsFormState,
    isOpenWebsiteContentsEditForm,
    setIsOpenWebsiteContentsEditForm,
    fetchWebContents,
    setFetchWebContents,
    webContentsFormData,
    setWebContentsFormData,
    // getFilterdata,

    // Website prompts form State values
    initialWebPromptsFormState,
    isOpenWebsitePromptsEditForm,
    setIsOpenWebsitePromptsEditForm,
    fetchWebPrompts,
    setFetchWebPrompts,
    webPromptsFormData,
    setWebPromptsFormData,

    //Messages
    initialMessageFormState,
    isOpenMessageEditForm,
    setIsOpenMessageEditForm,
    fetchMessage,
    setFetchMessage,
    messageFormData,
    setMessageFormData,

    // Countries form state values
    initialCountriesFormState,
    isOpenCountriesEditForm,
    setIsOpenCountriesEditForm,
    fetchCountries,
    setFetchCountries,
    countriesFormData,
    setCountriesFormData,

    //faq
    initialFaqFormState,
    isOpenFaqEditForm,
    setIsOpenFaqEditForm,
    fetchFaq,
    setFetchFaq,
    faqFormData,
    setfaqFormData,

    // System prompt form state values
    fetchSystemPrompts,
    setFetchSystemPrompts,
    isOpenSystemPrompsPreviewModal,
    setIsOpenSystemPromptsPreviewModal,

    // Config form state values
    fetchConfig,
    setFetchConfig,
    configCategories,
    setConfigCategories,

    userDetails,
    setUserDetails,
    formData,
    setFormData,
    initialFormState,
    tableData,
    // getSystemPromptData,
    // getConfigkeydata,
    initialConfigState,
    setIterinaryList,
    iterinaryList,
    iterinaryFormData,
    setIterinaryFormData,
    initialIterinaryFormData,
    setCurrentRoute,
    currentRoute,
    subCurrentRoute,
    setSubCurrentRoute,
  };

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
